export enum ResponseStatusCode {
  notFoundErrorCode = '40401',
  clientErrorCode = '40001',
  packNumberInUse = 'PackNumberInUse',
  invalidEngineeringNumber = 'InvalidEngineeringNumber',
  accountNotFound = 'AccountNotFound',
  InvalidDescription = 'InvalidDescription',
}
